import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { FlightComm, FrequencyMode } from '../models/flight-comm.model';
import { CommunicationService } from '../service/communication.service';
import { formatPhoneString, undoPhoneFormat } from '../../util/phone';
var EditCommunicationComponent = /** @class */ (function () {
    function EditCommunicationComponent(_matDialogRef, _snackBar, data, _commService) {
        this._matDialogRef = _matDialogRef;
        this._snackBar = _snackBar;
        this._commService = _commService;
        this.isNew = false;
        this.isLoading = true;
        this.selectedNewFreqMode = null;
        this.selectedNewFrequency = null;
        this.selectedNewPhone = null;
        this.selectedNewSector = null;
        this.newFrequencyText = 'Expand to add new frequency';
        this.newFrequencyPanelIsOpen = false;
        this.comm = data.comm || new FlightComm();
        this.isNew = data.isNew || false;
        this.airportId = data.airportId || data.comm.airportId;
        this.origComm = Object.assign(new FlightComm(), data.comm);
        if (this.comm.phoneNumber) {
            this.selectedPhone = formatPhoneString(this.comm.phoneNumber);
        }
        else {
            this.selectedPhone = null;
        }
        if (this.isNew) {
            this.selectedFreqMode = null;
        }
        else {
            this.selectedFreqMode = this.getFreqMode(this.comm.freqMode);
        }
    }
    EditCommunicationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
        this.formGroup = new FormGroup({
            type: new FormControl(this.comm.service, [Validators.required, Validators.maxLength(50)]),
            callSign: new FormControl(this.comm.radioCall, [Validators.maxLength(100)]),
            frequency: new FormControl(this.comm.frequency, [Validators.pattern('^-?\\d{0,6}\\.?\\d{0,3}$')]),
            freqMode: new FormControl(this.selectedFreqMode, [Validators.required]),
            phone: new FormControl(formatPhoneString(this.selectedPhone), [Validators.pattern('^([(]\\d{3}[)]\\s\\d{3}[-]\\d{4})$')]),
            sector: new FormControl(this.comm.sector, [Validators.maxLength(200)]),
            newFrequency: new FormControl('', [Validators.pattern('^-?\\d{0,6}\\.?\\d{0,3}$')]),
            newFreqMode: new FormControl(),
            newPhone: new FormControl('', [Validators.pattern('^([(]\\d{3}[)]\\s\\d{3}[-]\\d{4})$')]),
            newSector: new FormControl('', [Validators.maxLength(200)])
        });
        this.isLoading = false;
    };
    EditCommunicationComponent.prototype.getFreqMode = function (freqMode) {
        switch (freqMode) {
            case FrequencyMode.Duplex:
                return 'Duplex';
            case FrequencyMode.Receive:
                return 'Receive';
            case FrequencyMode.Transmit:
                return 'Transmit';
            case FrequencyMode.Unknown:
                return 'Unknown';
            default:
                return '';
        }
    };
    EditCommunicationComponent.prototype.setFreqMode = function (freqMode) {
        switch (freqMode) {
            case 'Duplex':
                return FrequencyMode.Duplex;
            case 'Receive':
                return FrequencyMode.Receive;
            case 'Transmit':
                return FrequencyMode.Transmit;
            case 'Unknown':
                return FrequencyMode.Unknown;
        }
    };
    EditCommunicationComponent.prototype.newFrequencyPanelOpened = function () {
        this.newFrequencyText = 'Enter new frequency info';
        this.newFrequencyPanelIsOpen = true;
        this.formGroup.controls['newFreqMode'].setValidators(Validators.required);
        this.formGroup.controls['newFreqMode'].updateValueAndValidity();
    };
    EditCommunicationComponent.prototype.newFrequencyPanelClosed = function () {
        this.newFrequencyText = 'Expand to add new frequency';
        this.newFrequencyPanelIsOpen = false;
        this.formGroup.controls['newFreqMode'].clearValidators();
        this.formGroup.controls['newFreqMode'].updateValueAndValidity();
    };
    /**
     * formats passed in phone number string;
     * @param {string} field
     * @param {string} value
     * @return {string}
     */
    EditCommunicationComponent.prototype.formatPhoneNumber = function (field, value) {
        var _a;
        var NEW_NUMBER = formatPhoneString(value);
        this.formGroup.patchValue((_a = {}, _a[field] = NEW_NUMBER, _a));
        return NEW_NUMBER;
    };
    /**
     * event triggered by keyup event on phone number or fax fields
     * @param event
     * @param {string} field
     * @param phoneInputObj
     */
    EditCommunicationComponent.prototype.phoneFieldKeyUp = function (event, field, phoneInputObj) {
        var value = this.formGroup.get(field).value;
        var rawValue = undoPhoneFormat(value);
        var KEY = event.key;
        if (KEY === 'Backspace' && rawValue.length === 10 && phoneInputObj.selectionStart === rawValue.length) {
            this.formatPhoneNumber(field, value);
        }
        else if (phoneInputObj.selectionStart < value.length) {
        }
        else if (KEY === 'Backspace' || KEY === 'ArrowLeft' || KEY === 'ArrowRight') {
            return;
        }
        else {
            this.formatPhoneNumber(field, value);
        }
    };
    /**
     * triggered when phone number or fax field goes out of focus
     * @param {string} field
     */
    EditCommunicationComponent.prototype.phoneFieldBlur = function (field) {
        var VALUE = this.formGroup.get(field).value;
        if (VALUE === '') {
            return;
        }
        this.formatPhoneNumber(field, VALUE);
    };
    /**
     * triggered by save button click event
     * @return {Promise<void>}
     */
    EditCommunicationComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var commResult, freqResult, newFreqResult, newFreq, newComm, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 8, , 9]);
                        commResult = void 0;
                        freqResult = void 0;
                        newFreqResult = void 0;
                        this.comm.service = this.formGroup.value.type;
                        this.comm.radioCall = this.formGroup.value.callSign;
                        this.comm.frequency = this.formGroup.value.frequency;
                        this.comm.freqMode = this.setFreqMode(this.formGroup.value.freqMode);
                        this.comm.phoneNumber = undoPhoneFormat(this.formGroup.value.phone);
                        this.comm.sector = this.formGroup.value.sector;
                        newFreq = null;
                        newComm = null;
                        if (this.newFrequencyPanelIsOpen) {
                            newFreq = new FlightComm();
                            newFreq.frequency = this.formGroup.value.newFrequency;
                            newFreq.freqMode = this.setFreqMode(this.formGroup.value.newFreqMode);
                            newFreq.phoneNumber = undoPhoneFormat(this.formGroup.value.newPhone);
                            newFreq.sector = this.formGroup.value.sector;
                            newFreq.flightCommId = this.comm.flightCommId;
                        }
                        if (!this.isNew) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._commService.postComm(this.airportId, this.comm)];
                    case 1:
                        commResult = _a.sent();
                        this.comm.flightCommId = commResult.flightCommId;
                        return [4 /*yield*/, this._commService.postFrequency(this.airportId, this.comm)];
                    case 2:
                        freqResult = _a.sent();
                        this.comm = this.combineCommAndFreqResults(commResult, freqResult);
                        return [3 /*break*/, 7];
                    case 3: return [4 /*yield*/, this._commService.putComm(this.airportId, this.comm)];
                    case 4:
                        commResult = _a.sent();
                        return [4 /*yield*/, this._commService.putFrequency(this.airportId, this.comm)];
                    case 5:
                        freqResult = _a.sent();
                        this.comm = this.combineCommAndFreqResults(commResult, freqResult);
                        if (!(newFreq != null)) return [3 /*break*/, 7];
                        return [4 /*yield*/, this._commService.postFrequency(this.airportId, newFreq)];
                    case 6:
                        newFreqResult = _a.sent();
                        newComm = this.combineCommAndFreqResults(commResult, newFreqResult);
                        _a.label = 7;
                    case 7:
                        this.close({ cancelBtnClicked: false, success: true, comm: this.comm, newComm: newComm });
                        return [3 /*break*/, 9];
                    case 8:
                        e_1 = _a.sent();
                        this.close({ cancelBtnClicked: false, success: false, error: e_1.error });
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    EditCommunicationComponent.prototype.combineCommAndFreqResults = function (comm, freq) {
        var flightCommReturn = new FlightComm();
        flightCommReturn.flightCommId = comm.flightCommId;
        flightCommReturn.service = comm.service;
        flightCommReturn.shortName = comm.shortName;
        flightCommReturn.radioCall = comm.radioCall;
        flightCommReturn.frequencyId = freq.frequencyId;
        flightCommReturn.frequency = freq.frequency;
        flightCommReturn.freqMode = this.setFreqMode(freq.freqMode);
        flightCommReturn.phoneNumber = freq.phoneNumber;
        flightCommReturn.sector = freq.sector;
        return flightCommReturn;
    };
    /**
     * triggered by cancel button click event
     */
    EditCommunicationComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    /**
     * closes modal
     * @param data
     */
    EditCommunicationComponent.prototype.close = function (data) {
        if (data && data.cancelBtnClicked) {
            Object.assign(this.comm, this.origComm);
        }
        data['isNew'] = this.isNew;
        this._matDialogRef.close(data);
    };
    return EditCommunicationComponent;
}());
export { EditCommunicationComponent };
